package uz.ferro.erp.feature.order.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.feature.user.model.User

@Serializable
data class  Order(
    val id: Long? = null,
    val uuid: String? = null,
    val deviceId: String? = null,
    val user: User? = null,
    val product: Product? = null,
    val localPrice: Double? = null,
    var status: OrderStatus? = null,
    var properties: List<OrderProperty>? = null,
    val createdDate: String? = null
)
